import {
  ReportItem,
  ReportItemConstructor,
  SimpleURLOptions,
} from './ReportItem'

export class SimpleReportItem<
  ID extends string,
  Name extends string,
  ClassType extends string,
  ClassTypeName extends string,
  Endpoint extends string,
  QueryParameter extends string,
  Label extends string,
  SampleFilename extends string,
  Key extends 'id' | 'globalId'
> extends ReportItem<
  ID,
  Name,
  ClassType,
  ClassTypeName,
  Endpoint,
  QueryParameter,
  Label,
  SampleFilename,
  SimpleURLOptions,
  Key
> {
  toURL({ globalId, ...options }: SimpleURLOptions): string {
    const url = this.__toURLObject(options)
    this.__addGlobalId(url, globalId)
    return url.toString()
  }
  constructor(
    options: ReportItemConstructor<
      ID,
      Name,
      ClassType,
      ClassTypeName,
      Endpoint,
      QueryParameter,
      Label,
      SampleFilename,
      Key
    >
  ) {
    super(options)
  }
}
